export const safeNumber = value => {
  if(value === null || value === undefined) return 0;
  if(typeof value === 'string') value = parseFloat(value);
  if(Number.isNaN(value)) return 0;
  return Number(value.toFixed(4));
}

export const weightInKgsPerUnit = component => {
  let weight = null;
  let isKg = true; // 1 - kg    2 - lb

  // shipping unit
  if(component.suweight !== undefined) {
    weight = safeNumber(component.suweight);
    if(component.suunitweight === "kgs") {
      isKg = true;
    } else if(component.suunitweight === "lbs") {
      isKg = false;
    } else {
      return 0;
    }
  } 
  // shipping lvl
  else {
    weight = safeNumber(component.weight);
    isKg = component.weightunit === 1;
  }

  const multiplier = isKg ? 1 : 0.45359237;
  return weight * multiplier;
}

export const isOverweight = component => {
  if(!component || !component.components || !component.components.length) return false;
  const parentWeight = weightInKgsPerUnit(component);
  const childrenWeight = component.components.reduce((total, child) => {
    return total + child.quantity * weightInKgsPerUnit(child);
  }, 0);
  return parentWeight < childrenWeight;
}

export const isOverweightDeep = component => {
  if(isOverweight(component)) return true;
  if(!component || !component.components || !component.components.length) return false;
  return component.components.some(isOverweightDeep);
}


// WEBPACK FOOTER //
// ./src/components/shippinglvls/shippingLvlUtils.js